import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'

import Snowflake from "../../components/Snowflake"
let createjs = window.createjs;

export default class Snow extends Component {

    constructor(props) {
        super(props)
        
        this.stage = null
        this.image = null
        
        this.snowContainer = null
        
        this.initialized = false
        this.state = this.addPropsToState(props, { imageData: null });
        
    }

    //define the puplic properties
    static propTypes = {
        pointData: PropTypes.string
    }
    
    handleOnDataChange(str, getDataUrl) {
        console.log('handleOnDataChange', str)
        //setTimeout(function(){
            this.setState({ imageData: getDataUrl() })
        //}.bind(this), 1000)
        
    }
    handleImageLoaded() {
        console.log('snow image loaded')
        var canvas = ReactDOM.findDOMNode(this.refs.canvas)
        this.image = ReactDOM.findDOMNode(this.refs.image)
        
        
        this.stage = new createjs.Stage(canvas);
        
        createjs.Ticker.on("tick", () => { this.stage.update() })

        //create a few in the middle
        for (var i = 0; i < 30; i++) {
            this.createSnow(true)
        }
        setInterval(this.createSnow.bind(this), 400)
    }

    createSnow(randY) {
        var duration = 2000
        var container = new createjs.Container()
        var snow = (!this.state.forceSimpleSnow) ? new createjs.Bitmap(this.image) : new createjs.Shape(new createjs.Graphics().beginFill('#fff').drawCircle(20,20,20))

        container.addChild(snow)
        snow.scale = .1 + Math.random() * .45;
        snow.alpha = 0
        var alpha = snow.scale

        container.y = -100 * snow.scale + (randY ? Math.random() * this.props.height*.8 : 0)
        container.x = Math.random() * this.props.width

        var totalTime = 10000*(this.props.height - container.y) / this.props.height
        !this.state.forceSimpleSnow && snow.cache(0, 0, 100, 100);
        container.snapToPixel = true
        
        this.stage.addChild(container)
        createjs.Tween.get(snow) 
            .to({ alpha: alpha }, 1000)
            
        createjs.Tween.get(snow, {loop:true})
            .to({ x: Math.random() * 25 - 25 }, duration + Math.random() * duration, createjs.Ease.quadInOut)
            .to({ x: 0 }, duration + Math.random() * duration, createjs.Ease.quadInOut)

        createjs.Tween.get(snow, { loop: true })
            .to({ rotation: 0 })
            .to({ rotation: Math.random() * 45 },   duration + Math.random() * duration, createjs.Ease.quadInOut)
            .to({ rotation: 0 }, duration + Math.random() * duration, createjs.Ease.quadInOut)

        createjs.Tween.get(container)
            .to({ y: this.props.height }, totalTime + Math.random()*5000)
            .call(this.removeContainer.bind(this));
        
        //this.stage.update()
    }

    removeContainer(e) {
        //console.log(e.target)
        this.stage.removeChild(e.target);
    }
    componentWillReceiveProps(nextProps) {
        this.setState(this.addPropsToState(nextProps, this.state))
        if (this.state.forceSimpleSnow === true) {
            this.handleImageLoaded()
        }
    }

    addPropsToState(props, state) {
        console.log('props.pointData', props.pointData)
        if (props.pointData && props.pointData !== '' && props.pointData.length < 1000) {
            state.pointData = props.pointData
            state.forceSimpleSnow = false
        } else {
            state.pointData = null
            state.forceSimpleSnow = true
        }
        return state
    }
    
    /**
     * Draw a new chart
     * @param data
     */
    

    shouldComponentUpdate(nextProps, nextState) {
        return true 
    }
    
    

    /**
     * Render Function
     * @returns {XML}
     */
    render() {
        return (
            <div className='snow' style={this.props.style}>

                <canvas ref="canvas"
                        width={this.props.width}
                        height={this.props.height}></canvas>
                {
                    this.state.pointData && <Snowflake mode={'view'} style={{ display: 'none' }} bgMode='transparent' onDataChange={this.handleOnDataChange.bind(this)}
                        width={100} height={100} pointData={this.state.pointData}
                    />
                }
                <img ref="image" alt="loader" style={{ display:'none' }} src={this.state.imageData} onLoad={this.handleImageLoaded.bind(this)} />
            </div>
        );
    }


}



// WEBPACK FOOTER //
// ./src/components/Snow/index.js